module.exports = __webpack_public_path__ + "img/2caa4e1d4393f30047d62a7ccba356c1.jpg";